module.exports = __webpack_public_path__ + "assets/60RotationCWDetailed.28dffbd33a78a4854761049cdf68cb82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/60RotationCWDetailed.png
// module id = 449
// module chunks = 0